import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import IMMSeo from './IMMSeo';

const IMM = () => {
  const [formData, setFormData] = useState({
    tc: '',
    plaka: '',
    telefon: '',
    kvkk: true
  });

  const agents = [
    { name: 'Ayşe', title: 'İMM Uzmanı', image: '👩‍💼', testimonial: "Size en uygun İMM teklifini sunalım." },
    { name: 'Kemal', title: 'Sigorta Danışmanı', image: '👨‍💼', testimonial: "İMM teminatınızı birlikte belirleyelim." },
    { name: 'Zeynep', title: 'İMM Sorumlusu', image: '👩‍💼', testimonial: "Aracınız için en iyi İMM koruması." },
    { name: 'Ahmet', title: 'Sigorta Uzmanı', image: '👨‍💼', testimonial: "İMM ile güvencenizi artıralım." }
  ];

  const [activeAgent, setActiveAgent] = useState(0);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * agents.length);
    setActiveAgent(randomIndex);

    const timer = setInterval(() => {
      setActiveAgent((prev) => (prev + 1) % agents.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="overflow-x-hidden">
      <Helmet>
        <title>İhtiyari Mali Mesuliyet (İMM) Sigortası | SigortamOlsun</title>
        <meta name="description" content="En uygun İMM sigortası tekliflerini anında karşılaştırın." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href="https://sigortamolsun.com/imm" />
      </Helmet>

      <div className="px-4 py-8">
        <div className="max-w-md mx-auto">
          {/* Agent Tabloları */}
          <div className="relative h-32 mb-4">
            {agents.map((agent, index) => (
              <div
                key={agent.name}
                className={`absolute w-full transition-all duration-500 transform
                  ${index === activeAgent ? 'scale-100 opacity-100' : 'scale-75 opacity-0'}
                  flex items-center gap-3 bg-blue-50 p-4 rounded-xl shadow-md border-2 border-blue-200`}
                style={{
                  transform: `translateX(${(index - activeAgent) * 100}%) scale(${index === activeAgent ? 1 : 0.75})`,
                  zIndex: index === activeAgent ? 10 : 0
                }}
              >
                <span className="text-2xl sm:text-3xl flex-shrink-0">{agent.image}</span>
                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-blue-900">{agent.name}</div>
                  <div className="text-sm text-blue-600">{agent.title}</div>
                  <div className="text-sm italic text-gray-500 break-words">{agent.testimonial}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Bilgilendirme */}
          <div className="text-center mb-6">
            <h1 className="text-xl sm:text-2xl font-semibold mb-4 whitespace-pre-line">
              {'Merhaba,\nBen İMM uzmanı '}<span className="text-blue-600">{agents[activeAgent].name}</span>{'.\nHemen teklif alalım.'}
            </h1>
            <p className="text-gray-600 text-sm">
              İMM sigortası teklifi almak için lütfen bilgilerinizi girin.
            </p>
          </div>

          {/* Form */}
          <form className="space-y-4">
            <input
              type="text"
              placeholder="TC Kimlik Numarası"
              className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600"
              maxLength="11"
              value={formData.tc}
              onChange={(e) => setFormData({ ...formData, tc: e.target.value })}
            />
            <input
              type="text"
              placeholder="Plaka"
              className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600"
              value={formData.plaka}
              onChange={(e) => setFormData({ ...formData, plaka: e.target.value })}
            />
            <input
              type="tel"
              placeholder="Telefon Numarası"
              className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600"
              value={formData.telefon}
              onChange={(e) => setFormData({ ...formData, telefon: e.target.value })}
            />

            <div className="flex items-start gap-2">
              <input
                type="checkbox"
                checked={formData.kvkk}
                onChange={(e) => setFormData({ ...formData, kvkk: e.target.checked })}
                className="mt-1"
              />
              <label className="text-sm text-gray-600">
                <Link to="/kvkk" className="text-gray-600 hover:text-blue-600 transition-colors">KVKK</Link>
                {' ve '}
                <Link to="/aydinlatma-metni" className="text-gray-600 hover:text-blue-600 transition-colors">site kullanım koşullarını</Link>
                {' kabul ediyorum'}
              </label>
            </div>

            <button className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition">
              Fiyat Al
            </button>
          </form>
        </div>
      </div>
      <IMMSeo />  
    </div>
  );
};

export default IMM;